<div class="col-xl-12 sub-success">
    <h2>Thank you!</h2>
    <h5>You have successfully <span>Subscribed</span></h5>
    <img src="assets/img/subscribe-success.png" width="439" />
    <a href="/login" class="btn btn-danger btn-mw">Done</a>
</div>